import {Component, Expressions} from '@packages/systems/wfdl';
import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {isOptimizationVariationElement} from '@packages/utilities/platform';
import {
  selectCurrentComponent,
  selectSelectedElement,
} from '@packages/utilities/platform-selectors';
import {createSelector} from 'reselect';

export function getIsSelectedElementOptimized(
  currentComponent: Component.ComponentType,
  selectedElement: ExpressionElement | null
): boolean {
  const componentRender = Component.getRender(currentComponent);
  const closestVariationElement =
    selectedElement &&
    Expressions.closestElement(
      componentRender,
      selectedElement.id,
      isOptimizationVariationElement
    );

  return Boolean(closestVariationElement);
}

export const isSelectedElementOptimized = createSelector(
  selectCurrentComponent,
  selectSelectedElement,
  getIsSelectedElementOptimized
);
